import { STRUCTURE_GRID_SIZE } from 'data/constants';
import { GridSpaceDataType, LevelType, PositionType } from 'data/types';
import { getSpacePolygonPx } from 'utils/point-clamp';
import { findSpaceById } from 'utils/structure';
import { SnapPolygonType } from 'utils/wall-snap-types';

export function objectCenterFeet(
  position: { x: number; y: number },
  objectSize: number
): PositionType {
  const halfFt = objectSize / STRUCTURE_GRID_SIZE / 2;
  return { x: position.x + halfFt, y: position.y + halfFt };
}

export function objectTopLeftFeet(
  center: PositionType,
  objectSize: number
): PositionType {
  const halfFt = objectSize / STRUCTURE_GRID_SIZE / 2;
  return { x: center.x - halfFt, y: center.y - halfFt };
}

export function gridSpaceSnapPolygon(
  space: GridSpaceDataType,
  structure?: LevelType[]
): SnapPolygonType {
  const openTo = structure
    ? findSpaceById(structure, space.spaceId)?.openTo
    : undefined;
  return {
    id: space.spaceId,
    vertices: getSpacePolygonPx(space).map((vertex) => ({
      x: vertex.x / STRUCTURE_GRID_SIZE,
      y: vertex.y / STRUCTURE_GRID_SIZE
    })),
    openTo
  };
}

export function gridSpaceSnapPolygons(
  spaces: GridSpaceDataType[],
  structure?: LevelType[]
): SnapPolygonType[] {
  return spaces.map((space) => gridSpaceSnapPolygon(space, structure));
}
